type FreshworksWidgetQueue = ((...args: unknown[]) => void) & {
    q: unknown[][];
};

export const getFreshworksWidget = (): FreshworksWidgetQueue => {
    if (typeof window.FreshworksWidget === "function") {
        return window.FreshworksWidget;
    }

    const widgetQueue = ((...args: unknown[]) => {
        widgetQueue.q.push(args);
    }) as FreshworksWidgetQueue;
    widgetQueue.q = [];
    window.FreshworksWidget = widgetQueue;

    return widgetQueue;
};

export const openFreshdeskTicketForm = () => {
    getFreshworksWidget()("open", "ticketForm");
};
